import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, HostListener, input } from '@angular/core';

import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

export interface MultiTooltipData {
  items: string[];
  title: string;
}

@Directive({
  selector: '[auxMultiTooltip]',
  standalone: true,
})
export class MultiTooltipDirective extends TooltipDirective {
  multiTooltip = input<string[]>([], { alias: 'auxMultiTooltip' });
  multiTooltipTitle = input<string>('');

  @HostListener('mouseenter')
  override show() {
    if (this.multiTooltip().length) {
      this.destroyOverlay();
      const positionStrategy = this.overlayPositionBuilder
        .flexibleConnectedTo(this.elementRef)
        .withPositions(this.positions);

      const overlayRef = this.overlay.create({
        positionStrategy,
      });
      const tooltipRef = overlayRef.attach(new ComponentPortal(TooltipComponent));

      tooltipRef.instance.title = this.multiTooltipTitle();
      tooltipRef.instance.items = this.multiTooltip();

      this.overlayRef = overlayRef;
    }
  }
}
